import {Injectable} from '@angular/core';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {FileDto, FileUploadProgressTypes, UploadProgress} from '../models/file';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {ConfigsLoaderService} from './config-loader.service';
import * as saveAs from 'file-saver';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';

@Injectable()
export class PublicFilesService {
  private apiEndPoint: string;
  private endpoint: string;
  constructor(private http: HttpClient,
              private config: ConfigsLoaderService,
              private fuseProgressBar: FuseProgressBarService) {
  this.apiEndPoint = this.config.apiUrl;
  }

  postFileWithProgress(file: FileDto, endpoint?: string): Observable<UploadProgress<FileDto>> {
    if(endpoint){
      this.endpoint = endpoint;
    } else{
      this.endpoint = 'Tenant/UploadFileTheme';
    }

    return this.http
      .post<FileDto>(`${this.apiEndPoint}/${this.endpoint}`, file, {reportProgress: true, observe: 'events'})
      .pipe(
        map(ev => {
          switch (ev.type) {
            case HttpEventType.UploadProgress:
              return {
                status: FileUploadProgressTypes.UPLOADING,
                progress: (ev.loaded / ev.total) * 100,
              };
            case HttpEventType.Response:
              return {
                status: FileUploadProgressTypes.FINISHED,
                progress: 100,
                data: ev.body,
              };
            case HttpEventType.DownloadProgress:
              return {
                status: FileUploadProgressTypes.PROCESSING,
                progress: 101,
              };
            default:
              return {
                status: FileUploadProgressTypes.LOADING,
              };
          }
        })
      );
  }

  downloadFileTemplate(templateId) {
    this.fuseProgressBar.show();
    return this.http
      .get<{ data: string, mimeType: string, fileName: string }>(`${this.apiEndPoint}/File/GetFileDownloadDto/${templateId}`)
      .pipe(
        tap(data => {
          fetch(`data:${data.mimeType};base64,${data.data}`)
            .then(res => res.blob())
            .then(blob => saveAs(blob, data.fileName))
            .catch(()=>this.fuseProgressBar.hide())
            .finally(()=> this.fuseProgressBar.hide());
        }),
      )
  }

}
